import * as React from 'react';
import cn from 'clsx';
import { ArticleHeading2, ArticleHeading3 } from '@cian/ui-kit';

import { NBSP } from '../../constants/symbols';
import { withDeviceType, IWithDeviceTypeProps } from '../../utils/withDeviceType/withDeviceType';
import { ClientTypeToggle } from './components';

import * as styles from './styles.css';

interface ICustomerRoleSectionProps extends IWithDeviceTypeProps {
  b2cPromoUrl: string;
  onClientTypeToggleLinkClick(): void;
}

const CustomerRoleSection: React.FC<React.PropsWithChildren<ICustomerRoleSectionProps>> = ({
  b2cPromoUrl,
  isPhone,
  isTablet,
  onClientTypeToggleLinkClick,
}) => {
  const TitleComponent = isPhone ? ArticleHeading3 : ArticleHeading2;

  return (
    <div className={cn(styles['container'], { [styles['phone']]: isPhone, [styles['tablet']]: isTablet })}>
      <TitleComponent color="black_100">
        В какой роли вы участвуете{NBSP}в{NBSP}сделке?
      </TitleComponent>
      <ClientTypeToggle b2cPromoUrl={b2cPromoUrl} onLinkClick={onClientTypeToggleLinkClick} />
    </div>
  );
};

const CustomerRoleSectionWithDeviceType = withDeviceType(CustomerRoleSection);
export { CustomerRoleSectionWithDeviceType as CustomerRoleSection };
